import audioPlayer from './audioPlayer.js';

let enterPage = {
  init: function() {
    const startPage = document.querySelector('.start-page');
    const enterBtns = startPage && startPage.querySelectorAll('.start-button-wrapper');
    const bgVideo = startPage && startPage.querySelector('.start-bg-video');
    if (!startPage || !enterBtns || !enterBtns.length) return;

    if (bgVideo) {
      const tryPlay = () => {
        const playPromise = bgVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      tryPlay();

      enterBtns.forEach(btn => {
        btn.addEventListener('mouseenter', () => {
          bgVideo.pause();
        });

        btn.addEventListener('mouseleave', () => {
          tryPlay();
        });
      });
    }

    const startExperience = () => {
      // Add fade-out class
      startPage.classList.add('fade-out');
      // After animation, hide start page
      startPage.addEventListener('animationend', function handler() {
        startPage.style.display = 'none';
        startPage.removeEventListener('animationend', handler);
      });
      // Play first audio track
      if (audioPlayer && typeof audioPlayer.playIndex === 'function') {
        audioPlayer.playIndex(0);
      }
    };

    enterBtns.forEach(btn => {
      btn.addEventListener('click', startExperience);
    });
  },
}
export default enterPage;